<template>
  <div class="">
    <Card class="">
      <template #title> Düzenle Öğün </template>
      <template #content>

        <div class=" grid">
          <div class="col-12">
            <Panel class="pb-5">

              <div class=" grid">
                <div class="col-3">
                  <div class="formgrid grid">
                    <div class="field col md:col-12">
                      <label for="OgunAd" class="font-bold block">Ogun Adı</label>
                      <InputText id="OgunAd" type="text" v-model="OgunAd" class="text-base text-color w-full"
                        :invalid="this.Valid.OgunAd" />
                    </div>
                    <div class="field col md:col-12">
                      <label for="Aciklama" class="font-bold block">Açıklama</label>
                      <Textarea id="Aciklama" v-model="Aciklama" rows="2" cols="30" :invalid="this.Valid.Aciklama"
                        class="text-base text-color w-full" />
                    </div>
                  </div>
                </div>
                <div class="col-9">

                </div>
              </div>
            </Panel>
          </div>

          <div class="col-12">
            <IslemYapiliyor v-if="IslemYapiliyor" />
          </div>
          <div class="col-12 flex justify-content-end flex-wrap">
            <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
              @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor" />
          </div>
        </div>

      </template>
    </Card>
  </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";

export default {
  data() {
    return {
      IslemYapiliyor: false,
      Ogun_rowid: 0,
      OgunAd: "",
      Aciklama: "",
      //--------------
      // Validation Elements
      Valid: {
        OgunAd: false,
        Aciklama: false,
      }
    };
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) { return; }
      this.IslemYapiliyor = true;


      let data = {
        Ogun_rowid: this.Ogun_rowid,
        Ad: this.OgunAd,
        Aciklama: this.Aciklama,
      };
      GlobalServis.GlobalServis("POST", "UpdateOgun", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Ogun oluşturulmuştur",
            life: 3000,
          });
          this._ResetForm();
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Diyetisyen/OgunListesi" });
      });
    },
    _OgunInfo() {
      this.Ogun_rowid = this.$route.query.OgunNo;
      let data = {
        Ogun_rowid: this.$route.query.OgunNo,
      };
      GlobalServis.GlobalServis("POST", "GetOgunInfo", data).then((res) => {
        if (res.status == 200) {

          this.OgunAd = res.data[0].Ad;
          this.Aciklama = res.data[0].Aciklama;

          this.IsWait = true;

        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
        this.$router.push({ path: "/Diyetisyen/OgunListesi" });
      });
    },
    _GetBirimListesi() {
      GlobalServis.GlobalServis("GET", "GetBirimListesi", "").then((res) => {
        if (res.status == 200) {
          this.BirimListesi = res.data;
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
      });
    },
    _ResetForm() {
      this.OgunAd = "";
      this.Aciklama = "";
    },
    _FormCheck() {
      let Check = false;
      if (this.OgunAd === "") {
        this.Valid.OgunAd = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Öğün adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.OgunAd = false; Check = false; }

      if (this.Aciklama === "") {
        this.Valid.Aciklama = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Açıklama girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.Aciklama = false; Check = false; }

      return Check;
    },
  },
  mounted() {
    this._OgunInfo();
  },
  components: {
  },
};
</script>